import { colors, Select, SwissSelect } from '@insurancemenu/imenu-components-lib';
import SubtitleWithLines from 'components/common/SubtitleWithLines';
import styled from 'styled-components';

export const FormStyled = styled.form`
  color: ${colors.neutral[900]};
`;

export const FormElementsStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
`;

export const SubtitleStyled = styled(SubtitleWithLines)`
  margin-bottom: 3rem;
`;

export const SelectStyled = styled(Select)`
  width: 100%;
`;

export const SwissSelectStyled = styled(SwissSelect)`
  width: 100%;
`;
